<template>
  <div class="version-wrapper">
    <p class="title" @click="openAbout">v.{{ pkg.version }}</p>

    <announcement-icon />
  </div>
</template>

<script>
import Package from "../../../../../package.json";
import AnnouncementIcon from "./AnnouncementIcon";

export default {
  name: "VersionViewer",
  components: {
    AnnouncementIcon
  },
  methods: {
    openAbout() {
      this.$modal.changeToComponent(this.$modal.modalType.About);
    }
  },
  data() {
    return {
      pkg: Package
    };
  }
};
</script>

<style lang="scss" scoped>
.version-wrapper {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  background-color: rgb(37, 42, 57);

  padding-left: 20px;
  padding-right: 20px;

  .title {
    width: auto;
    color: rgb(244, 244, 244);
    text-align: left;

    cursor: pointer;

    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/sidebar/VersionViewer.vue